import { Component, Inject, Input, OnInit, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpclientService } from 'src/app/admin/core/services/httpclientService';
import { ViewService } from 'src/app/admin/core/services/viewservice';
import { DynamicDocumentFieldInfoType } from 'src/app/shared/entities/dynamic-document';
import { Tables } from 'src/app/shared/entities/tables';

@Component({
  selector: 'filterpredefini',
  templateUrl: './filtre-predifini-dialog.component.html',
  styleUrls: ['./filtre-predifini-dialog.component.css'],
})
export class FiltrePredifiniDialogComponent implements OnInit {
  @Input() tab: Tables;
  listdechamps: any[] = [];
  filter: any[] = [];
  nom: string = '';
  private typeCondition: string;
  // champType: string;

  private choixConditionsParType: { [key: string]: any[] };

  public choixConditions: any[];

  public conditions: any[] = [];
  filters: { [key: string]: any } = {};
  filterTypes: any = null;

  public peuxEffacerRecherche: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialogRef<any>,
    private httpClient: HttpclientService,
    private viewService: ViewService,
  ) { }

  ngOnInit(): void {
    this.loadConditions();
    this.loadChamps();

    this.filterTypes = this.tab.filterTypes;
    this.nom = this.tab.view.nom;
    this.fillConditions();
  }

  loadChamps() {
    let codes = this.data.nouveauxChamps.map((el: any) => el.nom);
    let labels = this.data.nouveauxChamps.map((el: any) => el.label.fr_FR);
    codes.forEach((cod: any, i: number) => {
      this.listdechamps.push({ code: cod, label: labels[i] });
    });
  }

  loadConditions() {
    this.choixConditionsParType = this.viewService.filterConditions();
  }

  public ajouterCondition(): void {
    this.conditions.push({
      id: this.conditions.length,
      type: this.typeCondition,
      condition: '',
      valeur: '',
      champ: '',
    });
  }

  fillConditions() {
    if (
      this.tab.view.filter === undefined ||
      this.tab.view.filter === null ||
      this.tab.view.filter.length === 0
    ) {
      this.conditions.push({
        id: this.conditions.length,
        type: this.typeCondition,
        condition: '',
        valeur: '',
        value: '',
        champ: '',
      });
    } else {
      for (let filter of this.tab.view.filter) {
        const pushCondition = {
          id: this.conditions.length,
          type: filter.type,
          condition: filter.conditions[0].condition ?? filter.conditions[0].type,
          valeur: filter.conditions[0].valeur ?? filter.conditions[0].value,
          value: filter.conditions[0].valeur ?? filter.conditions[0].value,
          champ: filter.champ ?? filter.fieldName
        }

        this.populerCondition(filter.fieldName, pushCondition);

        this.conditions.push(pushCondition);
      }

      this.peuxEffacerRecherche = true;
    }
  }

  getChampType(code: any) {
    let champType;

    let matchingField = this.data.nouveauxChamps.find(
      (el: any) => el?.nom == code
    );
    if (matchingField) {
      switch (matchingField.type) {
        case DynamicDocumentFieldInfoType.NUMBER:
        case DynamicDocumentFieldInfoType.BOOLEAN:
        case DynamicDocumentFieldInfoType.TEXT:
          champType = matchingField.type;
          break;
        case DynamicDocumentFieldInfoType.DATE_TIME:
          champType = 'DATE';
          break;

        case DynamicDocumentFieldInfoType.PARAMETER_LINKS:
          champType = 'PARAMETER_LINKS';
          break;

        case DynamicDocumentFieldInfoType.PARAMETER_LINK:
        case DynamicDocumentFieldInfoType.DOCUMENT_LINK:
        case DynamicDocumentFieldInfoType.DOCUMENT_LINKS:
          champType = 'LINK';
          break;
        default:
          champType = 'UNKNOWN';
      }
    }

    return champType;
  }

  populerCondition(code: any, condition: any): void {
    let champType = this.filterTypes?.[code];
    if (!champType) champType = 'UNKNOWN';

    if (this.tab.isDynamic) {
      champType = this.getChampType(code);
    }
    condition.choixConditions = this.choixConditionsParType[champType];
    condition.champType = champType;

    condition.condition = condition.choixConditions[0]?.value ?? null;
    this.getDynamicInfoByField(code, condition);
    // this.choixConditions = this.choixConditionsParType[this.champType];
  }


  getDynamicInfoByField(fieldName: string, condition: any) {
    condition.isParameterField = false;
    condition.isMultipleParameterField = false;

    if (this.tab.isDynamic) {
      this.httpClient
        .get(`dynamic-document-infos/${this.tab.entite}/${fieldName}`)
        .subscribe((references) => {

          if (references !== null && references.length > 0) {
            condition.isParameterField = true;
            condition.isMultipleParameterField = false;

            condition.parameters = references
              .filter((reference: any) => reference['valeur'] !== undefined)
              .map((reference: any) => {
                return {
                  // valeur: reference['mapLocalLibelle'][locale ? locale : 'fr_FR'],
                  valeur: reference['mapLocalLibelle']['fr_FR'], // On va regarder ca apres le demo
                  value: reference['valeur'],
                };
              });

            (!condition.valeur) && (condition.valeur = condition.parameters[0]?.value ?? null);
            (!condition.value) && (condition.value = condition.parameters[0]?.value ?? null);
          } else {

            if (condition.champType === DynamicDocumentFieldInfoType.PARAMETER_LINKS) {
              const nomTableField = this.tab.allFields.find((item: any) => item.name === fieldName)?.parameterLinkName ?? '';
              if (nomTableField) {
                this.httpClient
                  .get(`parametre/nomtable/${nomTableField}`)
                  .subscribe((references) => {
                    if (references !== null && references.length > 0) {
                      condition.isParameterField = true;
                      condition.isMultipleParameterField = true;

                      condition.parameters = references
                        .filter((reference: any) => reference['valeur'] !== undefined)
                        .map((reference: any) => {
                          return {
                            valeur: reference['mapLocalLibelle']['fr_FR'],
                            value: reference['valeur'],
                          };
                        });
                    }
                  });
              }

            }
          }
        });
    }
  }

  public supprimerCondition(id: number): void {
    const condition = this.conditions.find((t) => t.id === id);
    if (condition !== undefined) {
      this.conditions.splice(this.conditions.indexOf(condition), 1);
    }

    if (this.conditions.length === 0) {
      this.ajouterCondition();
    }
  }

  public rechercher(): void {
    if (this.conditions.length > 0) {
      this.filter = [];
      for (let condition of this.conditions) {
        this.filter.push({
          champ: condition.champ,
          fieldName: condition.champ,
          conditions: [
            {
              condition: condition.condition,
              valeur: condition.valeur,
              value: condition.valeur,
              type: condition.condition,
            },
          ],
        });
      }

      this.tab.view.filter = this.filter;
      this.dialog.close(this.tab.view.filter);
    } else {
      this.tab.view.filter = [];
      this.dialog.close(null);
    }
  }

  updateConditionValue(condition: any, value: any): void {
    condition.value = value;
    condition.valeur = value;
  }
  public effacerFiltres(): void {
    this.tab.view.filter = [];
    this.dialog.close(null);
  }

  public boutonrechercherdesactive(): boolean {
    if (this.conditions.length > 0) {
      for (const condition of this.conditions) {
        if (condition.condition === '') {
          return true;
        }
        if (
          condition.condition !== 'IS_EMPTY' &&
          condition.condition !== 'IS_NOT_EMPTY'
        ) {
          if (condition.valeur === '') {
            return true;
          }
        }
      }
    }
    return false;
  }

  public fermer(): void {
    this.dialog.close();
  }
  isDate(champType: string): boolean {
    return champType === 'DATE';
  }

  isBoolean(champType: string): boolean {
    return champType === 'BOOLEAN';
  }

  /**
   * Xử lý phím Enter để áp dụng bộ lọc
   * Chỉ áp dụng khi nút VALIDER không bị disable
   */
  @HostListener('keydown.enter', ['$event'])
  onEnterKeyDown(event: KeyboardEvent): void {
    // Kiểm tra nếu đang focus vào textarea hoặc select đang mở thì không xử lý
    const target = event.target as HTMLElement;
    if (target.tagName === 'TEXTAREA' || target.closest('.mat-select-panel')) {
      return;
    }

    // Ngăn chặn hành vi mặc định (submit form)
    event.preventDefault();
    event.stopPropagation();

    // Chỉ áp dụng filter nếu nút không bị disable
    if (!this.boutonrechercherdesactive()) {
      this.rechercher();
    }
  }
}
